module.exports = __webpack_public_path__ + "static/img/404.a57b6f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images_404/404.png
// module id = ckhv
// module chunks = 6